export default __webpack_public_path__ + "c419fbabfdea180ceaf10d231c4ba005.svg";